import { useEffect, useState } from 'react';
import { subscribeProductorPorEmail } from '../services/productoresService';

/**
 * Resuelve si el usuario logueado es un productor del padrón `productores`.
 *
 * Devuelve { productor, isLoading }:
 * - isLoading: true hasta que Firestore responde (la app no debe mostrar la
 *   selección de rol ni la planilla completa antes de saber esto).
 * - productor: el documento del padrón, o null si el usuario es personal
 *   interno (no figura en el padrón).
 *
 * Es una suscripción en vivo: si un productor se desactiva o cambian sus
 * clientes mientras está logueado, la vista se actualiza sola.
 *
 * La respuesta se guarda junto con el email al que corresponde y isLoading se
 * deriva en el render: así, en el render en que aparece el usuario (antes de que
 * corra el efecto) ya vale true. Si saliera del estado, ese primer render diría
 * "respondió y no está en el padrón", y la app le cerraría la sesión a todo
 * productor con una cuenta externa.
 */
export const useProductorActual = (user) => {
  const email = user?.email || null;
  const [respuesta, setRespuesta] = useState({ email: null, productor: null });

  useEffect(() => {
    if (!email) return undefined;
    return subscribeProductorPorEmail(
      email,
      (productor) => setRespuesta({ email, productor }),
      // Si la lectura falla se sigue el flujo de personal interno: las reglas
      // de Firestore igual bloquean los datos que no le corresponden.
      () => setRespuesta({ email, productor: null }),
    );
  }, [email]);

  if (!email) return { productor: null, isLoading: false };
  const isLoading = respuesta.email !== email;
  return { productor: isLoading ? null : respuesta.productor, isLoading };
};
